import script from "./FakeTaskItem.vue?vue&type=script&setup=true&lang=js"
export * from "./FakeTaskItem.vue?vue&type=script&setup=true&lang=js"

import "./FakeTaskItem.vue?vue&type=style&index=0&id=be32cb96&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-be32cb96"]])

export default __exports__